import { render, staticRenderFns } from "./pdf_multas.vue?vue&type=template&id=2ca6665b&scoped=true&"
import script from "./pdf_multas.vue?vue&type=script&lang=js&"
export * from "./pdf_multas.vue?vue&type=script&lang=js&"
import style0 from "./pdf_multas.vue?vue&type=style&index=0&id=2ca6665b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6665b",
  null
  
)

export default component.exports